import { Box, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { theme } from "../../theme/theme";
import { CustomInput } from "../Common/CustomInput";
import { SearchOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const columns = [
  {
    field: "id",
    headerName: "#ID",
    width: 70,
    headerClassName: "super-app-theme--header",
    renderCell: (params) => (
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Regular",
          ml: 0.5,
        }}
      >
        {params.value}
      </Typography>
    ),
  },
  {
    field: "fullName",
    headerName: "FULL NAME",
    flex: 1,
    headerClassName: "super-app-theme--header",
    renderCell: (params) => (
      <Box sx={{ display: "flex" }}>
        <Typography
          sx={{
            color: "#fff",
            fontFamily: "Mulish-Bold",
          }}
        >
          {params?.row?.participants?.firstName +
            " " +
            params?.row?.participants?.lastName}
        </Typography>
      </Box>
    ),
  },
  {
    field: "phone",
    headerName: "PHONE NO.",
    flex: 1,
    headerClassName: "super-app-theme--header",
    renderCell: (params) => (
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Regular",
        }}
      >
        {params.row?.participants?.mobile}
      </Typography>
    ),
  },
  {
    field: "email",
    headerName: "EMAIL",
    flex: 1.5,
    headerClassName: "super-app-theme--header",
    renderCell: (params) => (
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Regular",
        }}
      >
        {params.row?.participants?.email}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "STATUS",
    flex: 1,
    headerClassName: "super-app-theme--header",
    renderCell: (params) => (
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Regular",
          textTransform: "capitalize",
        }}
      >
        {params.value}
      </Typography>
    ),
  },
  {
    field: "pastEvents",
    headerName: "PAST EVENT(S)",
    flex: 1,
    headerClassName: "super-app-theme--header",
    renderCell: (params) => (
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Regular",
        }}
      >
        -
      </Typography>
    ),
  },
  {
    field: "createdAt",
    headerName: "TIMESTAMP",
    flex: 1.2,
    headerClassName: "super-app-theme--header",
    renderCell: (params) => (
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Regular",
        }}
      >
        {dayjs(params.value).format("DD/MM/YYYY hh:mm")}
      </Typography>
    ),
  },
  {
    field: "action",
    headerName: "ACTION",
    flex: 0.5,
    sortable: false,
    renderCell: () => "⋮",

    headerClassName: "super-app-theme--header",
  },
];

const EventParticipantTable = ({ eventData, allParticipants }) => {
  const [search, setSearch] = useState("");

  const { userData } = useSelector((state) => state.user);

  const filteredParticipants = allParticipants?.filter((participant) => {
    const fullName =
      `${participant?.participants?.firstName} ${participant?.participants?.lastName}`.toLowerCase();
    const email = participant?.participants?.email?.toLowerCase();

    return (
      fullName.includes(search.toLowerCase()) ||
      email?.includes(search.toLowerCase())
    );
  });

  return (
    <Box sx={{ mt: 2 }}>
      <Stack
        width={"100%"}
        direction="row"
        alignItems="center"
        justifyContent={"space-between"}
        mb={2}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography
            sx={{
              color: "#fff",
              fontSize: "20px",
              fontFamily: "Mulish-Medium",
            }}
          >
            Participants ({allParticipants?.length || 0})
          </Typography>
          {/* <Box
            sx={{
              backgroundColor: "transparent",
              border: "1px solid rgba(255,255,255,0.22)",
              borderRadius: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              color: "#fff",
              fontFamily: "Mulish-Light",
              fontSize: "12px",
            }}
          >
            Going (41)
          </Box>
          <Box
            sx={{
              backgroundColor: "transparent",
              border: "1px solid rgba(255,255,255,0.22)",
              borderRadius: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              color: "#fff",
              fontFamily: "Mulish-Light",
              fontSize: "12px",
            }}
          >
            Invited (11)
          </Box> */}
        </Stack>

        <Box sx={{ width: "100%", maxWidth: "400px" }}>
          <CustomInput
            value={search}
            handleChange={(e) => setSearch(e.target.value)}
            rightIcon
            Icon={SearchOutlined}
            borderColor={"rgba(247,132,25,0.5)"}
            placeholder="Search..."
            type="text"
            bR={"14px"}
            color={"#fff"}
            width={"100%"}
          />
        </Box>
      </Stack>
      <Box
        sx={{
          backgroundColor: "transparent",
          "& .super-app-theme--header": {
            border: "none !important",
            backgroundColor: "transparent !important",
          },
          "& .MuiDataGrid-root": {
            "--DataGrid-t-color-background-base": "transparent",
            border: theme.lightBorder,
            borderRadius: "18px",
            backgroundColor: "transparent",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "transparent !important",
              color: "#fff",
              fontFamily: "Mulish-Medium",
              fontSize: "14px",
              borderBottom: theme.lightBorder,
              borderRadius: "14px",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              backgroundColor: "transparent",
              color: "#fff",
              fontFamily: "Mulish-Regular",
              border: "none",
              display: "flex",
              alignItems: "center",
            },
            "& .MuiDataGrid-row:nth-of-type(2n)": {
              backgroundColor: "#192234",
              borderRadius: "14px",
            },
            "& .MuiDataGrid-row:nth-of-type(2n+1)": {
              backgroundColor: "transparent",
            },
          },
        }}
      >
        <DataGrid
          rows={filteredParticipants || []}
          columns={columns}
          disableRowSelectionOnClick
          hideFooter
          autoHeight
        />
      </Box>
    </Box>
  );
};

export default EventParticipantTable;
